import { render, staticRenderFns } from "./inputmap.vue?vue&type=template&id=0cae109c&scoped=true&"
import script from "./inputmap.vue?vue&type=script&lang=js&"
export * from "./inputmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae109c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cae109c')) {
      api.createRecord('0cae109c', component.options)
    } else {
      api.reload('0cae109c', component.options)
    }
    module.hot.accept("./inputmap.vue?vue&type=template&id=0cae109c&scoped=true&", function () {
      api.rerender('0cae109c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/inputmap.vue"
export default component.exports